import { useMemo } from 'react';
import React from 'react';
import EChartCommon from '@op/components/EChartCommon';
import { chartAllColors } from '@/pages/opinion/constants';
import { scoreFormat } from '@/pages/opinion/utils/value';
import { mathFormat } from '@/pages/opinion/utils';

interface CPieChartProps {
  /**中间显示的数据名称 */
  title?: string;
  /**格式化后的数据源 */
  seriesData: any[];
  /**高度 */
  height?: number;
  loading: boolean;
  tooltipFormatterFunc: any;
  formatValue: any;
}

export default function PieChart({
  loading,
  title,
  seriesData,
  height = 300,
  tooltipFormatterFunc,
  formatValue,
}: CPieChartProps) {
  /**
   * 获取自定义的配置
   * @returns
   */
  const getOptions = () => {
    const total = seriesData?.reduce((pre, cur) => pre + cur.value, 0) || 0;

    return {
      // 标题的配置
      title: {
        text: '{name|' + formatValue(total, 2) + '}',
        top: '40%',
        left: 'center',
        textStyle: {
          rich: {
            name: {
              fontSize: 24,
              fontFamily: 'num-m',
              color: '#000000',
              padding: [10, 0],
            },
          },
        },
      },
      // series的配置
      series: {
        data: seriesData,
        color: chartAllColors,
      },
      tooltip: {
        formatter: (param: any) => tooltipFormatterFunc(param),
      },
    };
  };

  const options = useMemo(() => {
    return getOptions();
  }, [seriesData]);

  return (
    <EChartCommon
      options={options}
      loading={loading}
      empty={seriesData.length === 0}
      height={height}
      optionsProps={{
        type: 'pie',
        pieLabelAlignTo: 'none',
        pieValueFormat: formatValue,
      }}
    ></EChartCommon>
  );
}
